import { ROUTES } from '@/router/routeNames'
import integrationRoutes from '@/modules/integration/integrationRoutes'
import attributionRoutes from '@/modules/attribution/attributionRoutes'

export default [
  {
    name: ROUTES.SETTINGS,
    path: 'settings',
    component: () => import('./pages/SettingsIndex.vue'),
    redirect: { name: ROUTES.SETTINGS_OPTIONS },
    meta: { settingsMode: true },
    children: [
      // Project
      {
        name: ROUTES.SETTINGS_OPTIONS,
        path: 'options',
        component: () => import('./pages/SettingsOptions.vue'),
        meta: {
          settingsMode: true,
          title: 'General',
          description: 'Project name, flow defaults, visitor identification, and other core settings.'
        }
      },
      {
        name: ROUTES.SETTINGS_DOMAINS,
        path: 'domains',
        component: () => import('./pages/SettingsDomains.vue'),
        meta: {
          settingsMode: true,
          title: 'Domains',
          description: 'Configure which domains RightMessage should run on and enable cross-domain tracking.'
        }
      },
      {
        name: ROUTES.SETTINGS_SNIPPET,
        path: 'snippet',
        component: () => import('./pages/SettingsSnippet.vue'),
        meta: {
          settingsMode: true,
          title: 'JavaScript Snippet',
          description: 'Install the RightMessage tracking snippet on your website to start personalizing.'
        }
      },
      ...integrationRoutes,
      ...attributionRoutes,

      // Features
      {
        name: ROUTES.SETTINGS_AI,
        path: 'ai',
        component: () => import('./pages/SettingsAI.vue'),
        meta: {
          settingsMode: true,
          title: 'AI Settings',
          description: 'Configure AI-powered features including content generation language and business context.'
        }
      },
      {
        name: ROUTES.SETTINGS_BRANDING,
        path: 'branding',
        component: () => import('./pages/SettingsBranding.vue'),
        meta: {
          settingsMode: true,
          title: 'Powered By',
          description: 'Control RightMessage branding on your widgets and popups.'
        }
      },
      {
        name: ROUTES.SETTINGS_ADVANCED,
        path: 'advanced',
        component: () => import('./pages/SettingsAdvanced.vue'),
        meta: {
          settingsMode: true,
          title: 'Advanced',
          description: 'Advanced project behavior controls, including real-time sync of remote configuration changes.'
        }
      },

      // Account
      {
        name: ROUTES.SETTINGS_COLLABORATORS,
        path: 'collaborators',
        component: () => import('./pages/SettingsCollaborators.vue'),
        meta: {
          settingsMode: true,
          title: 'Collaborators',
          description: 'Manage who has access to this project and their permission levels.'
        }
      },
      {
        name: ROUTES.SETTINGS_BILLING,
        path: 'billing',
        component: () => import('./pages/SettingsBilling.vue'),
        meta: {
          settingsMode: true,
          title: 'Billing',
          description: 'Manage your subscription, view invoices, and update payment details.'
        }
      },
      {
        name: ROUTES.SETTINGS_DATA,
        path: 'data',
        component: () => import('./pages/SettingsData.vue'),
        meta: {
          settingsMode: true,
          title: 'Your Data',
          description: 'Export your project data or reset analytics.'
        }
      }
    ]
  },
  {
    name: ROUTES.PROFILE,
    path: 'profile',
    component: () => import('./pages/ProfileShow.vue'),
    redirect: { name: ROUTES.PROFILE_PERSONAL },
    meta: { profileMode: true },
    children: [
      {
        name: ROUTES.PROFILE_PERSONAL,
        path: 'personal',
        component: () => import('./pages/ProfilePersonalPage.vue'),
        meta: {
          profileMode: true,
          title: 'Personal & Password',
          description: 'Update your name, email, affiliate ID, and password.'
        }
      },
      {
        name: ROUTES.PROFILE_PROJECTS,
        path: 'projects',
        component: () => import('./pages/ProfileProjectsPage.vue'),
        meta: {
          profileMode: true,
          title: 'Owned Projects',
          description: 'View and manage the projects you own.'
        }
      },
      {
        name: ROUTES.PROFILE_AI_CONNECTIONS,
        path: 'ai-connections',
        component: () => import('./pages/ProfileAiConnectionsPage.vue'),
        meta: {
          profileMode: true,
          title: 'AI Connections',
          description: 'Review and disconnect hosted OAuth clients such as ChatGPT and Claude.'
        }
      },

      {
        name: ROUTES.PROFILE_API_TOKENS,
        path: 'api-tokens',
        component: () => import('./pages/ProfileApiTokensPage.vue'),
        meta: {
          profileMode: true,
          title: 'API Tokens',
          description: 'Create and manage API tokens for programmatic access to your projects.'
        }
      },
      {
        name: ROUTES.PROFILE_AGENCY_SETTINGS,
        path: 'agency',
        component: () => import('./pages/ProfileAgencySettingsPage.vue'),
        meta: {
          profileMode: true,
          title: 'Agency Settings',
          description: 'Configure your agency profile, branding, and partner directory listing.'
        }
      },
      {
        name: ROUTES.PROFILE_AGENCY_CLIENTS,
        path: 'agency-clients',
        component: () => import('./pages/ProfileAgencyClientsPage.vue'),
        meta: {
          profileMode: true,
          title: 'Agency Clients',
          description: 'Manage client accounts and invitations for your agency.'
        }
      },
      {
        name: ROUTES.PROFILE_BILLING,
        path: 'billing',
        component: () => import('./pages/ProfileBillingPage.vue'),
        meta: {
          profileMode: true,
          title: 'Billing & Invoices',
          description: 'View your subscription details, invoices, and manage payment methods.'
        }
      }
    ]
  },
  {
    name: ROUTES.UPGRADE,
    path: 'upgrade',
    component: () => import('./pages/Upgrade.vue')
  },
  {
    name: ROUTES.REVIEW_SESSION,
    path: 'review-session',
    component: () => import('./pages/ReviewSession.vue')
  }
]
